var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-interpreting-modal-component" }, [
    _c(
      "div",
      { staticClass: "room-interpreting-modal" },
      [_c(_vm.interpretingComponent, { tag: "component" })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }